// components/OperationDashboard/ViewToggleButton.js
import React from "react";
import { Button, alpha, useTheme } from "@mui/material";

const ViewToggleButton = ({ mode, label, icon, viewMode, setViewMode }) => {
  const theme = useTheme();

  return (
    <Button
      variant={viewMode === mode ? "contained" : "outlined"}
      onClick={() => setViewMode(mode)}
      startIcon={icon}
      size="small"
      sx={{
        textTransform: "none",
        borderRadius: 2,
        fontWeight: 600,
        fontSize: "0.75rem",
        ...(viewMode === mode
          ? {
              bgcolor: theme.palette.primary.main,
              "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.8) },
            }
          : {
              borderColor: alpha(theme.palette.primary.main, 0.2),
              color: "text.primary",
              "&:hover": {
                borderColor: theme.palette.primary.main,
                bgcolor: alpha(theme.palette.primary.main, 0.04),
              },
            }),
      }}
    >
      {label}
    </Button>
  );
};

export default ViewToggleButton;